import React from 'react'

function User ({ className, fill }) {
  return (
    <svg fill={fill} className={className} width="18.284" height="20.5" viewBox="0 0 18.284 20.5">
      <g transform="translate(0 -0.5)">
        <path d="M90.042,9.919A4.709,4.709,0,1,1,94.751,5.21,4.714,4.714,0,0,1,90.042,9.919Zm0-8.311a3.6,3.6,0,1,0,3.6,3.6A3.6,3.6,0,0,0,90.042,1.608Zm0,0" transform="translate(-80.9)"/>
        <path d="M18.284,213.141H0v-.831a9.142,9.142,0,0,1,18.284,0Zm-17.164,0H17.18c0-5.43-3.7-8.865-8.032-8.865a8.452,8.452,0,0,0-7.133,4.415A10.3,10.3,0,0,0,1.12,213.141Z" transform="translate(0 -192.141)"/>
      </g>
    </svg>
  )
}

User.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default User
